import type { Category } from "../types";
import { ProductType } from "@/common/course/types";

function isOpenCoursesCategory(category: Category): boolean {
  return (
    category.key === "course" ||
    category.categoryLabel === "Courses" ||
    category.productType === ProductType.COURSE
  );
}

/** Puts the open-courses / Courses tab first; preserves relative order of all other configured categories. */
export function prioritizeOpenCoursesTab(categories: Category[]): Category[] {
  const idx = categories.findIndex(isOpenCoursesCategory);
  if (idx <= 0) return categories;
  const next = [...categories];
  const [courses] = next.splice(idx, 1);
  return [courses, ...next];
}
